export default __webpack_public_path__ + "static/media/4-2_image07@2x.7f0b62bb.png";